import { useState, useEffect } from 'react';

export default function useTab() {
  const [isTab, setIsTab] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1200
  );

  useEffect(() => {
    const handleResize = () => {
      setIsTab(window.innerWidth >= 768 && window.innerWidth < 1200);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isTab;
}